import product1 from "../../assets/images/product1.jpg";
import cartdemo from "../../assets/images/cartdemo.png";
export const data = [
  {
    id: 1,
    img: product1,
    title: "台紙 三面台紙 三冊",
    qty: 1,
    price: "￥27,500",
  },
  {
    id: 2,
    img: product1,
    title: "台紙 三面台紙 三冊",
    qty: 1,
    price: "￥27,500",
  },
  {
    id: 3,
    img: cartdemo,
    title: "台紙 三面台紙 三冊",
    qty: 1,
    price: "￥27,500",
  },
];
